exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._3iABEk-N31X9Dt_qg16I_R{display:flex;margin:40px 30px 40px 30px}._1ZIwjBtir_hP9qIPKGApjW{flex:0 1 50%;position:relative}._3vMujCyfFDfownvxf6DhgD{flex:1 1 50%;display:flex;align-items:center}\n", ""]);

// Exports
exports.locals = {
	"appStoreCancelDialog": "_3iABEk-N31X9Dt_qg16I_R",
	"phoneImg": "_1ZIwjBtir_hP9qIPKGApjW",
	"instructions": "_3vMujCyfFDfownvxf6DhgD"
};